module.exports = __webpack_public_path__ + "img/Vector 40.40abb38a.png";